import { getEnvOrThrow } from '@monkvision/common';
import { Auth0ContextInterface, Auth0Provider, AuthorizationParams } from '@auth0/auth0-react';
import { createContext, PropsWithChildren } from 'react';
import { MonkAuthHandle, useAuth as useMonkAuth } from '@monkvision/network';

const AUTH_CLIENT_ID = getEnvOrThrow('REACT_APP_AUTH_CLIENT_ID');
const DOMAIN = getEnvOrThrow('REACT_APP_AUTH_DOMAIN');
const AUTHORIZATION_PARAMS: AuthorizationParams = {
  redirect_uri: window.location.origin,
  audience: getEnvOrThrow('REACT_APP_AUTH_AUDIENCE'),
  prompt: 'login',
};

const AUTH_CONTEXT = createContext(null as unknown as Auth0ContextInterface);

export function AuthProvider({ children }: PropsWithChildren<unknown>) {
  return (
    <Auth0Provider
      domain={DOMAIN}
      clientId={AUTH_CLIENT_ID}
      authorizationParams={AUTHORIZATION_PARAMS}
      context={AUTH_CONTEXT}
    >
      {children}
    </Auth0Provider>
  );
}

export function useAuth(): MonkAuthHandle {
  return useMonkAuth({ context: AUTH_CONTEXT });
}
